module.exports = __webpack_public_path__ + "static/img/can-mangolime-bublyburst@2x.27a2c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-mangolime-bublyburst@2x.png
// module id = RIhb
// module chunks = 0